import React from "react";
import { ProductDataType } from "../../../types";

import { mdiLoading } from "@mdi/js";
import Icon from "@mdi/react";

interface Props {
    stock?: ProductDataType["stock"];
    loading?: boolean;
}

export default function StockIndicator({ stock, loading = false }: Props) {
    let className = "inline-block py-1 px-3 uppercase text-xs font-extrabold";

    if (!stock || loading) {
        return (
            <div className={className}>
                <Icon path={mdiLoading} spin={1} size={1} />
            </div>
        );
    }

    return (
        <div
            className={className}
            style={{
                backgroundColor: stock.color,
                color: stock.fontColour || "white"
            }}
        >
            <div className="flex items-center">
                <div>
                    {stock.text}
                </div>
                {stock?.presaleDate && (
                    <>
                        <span className="px-1">|</span>
                        <div className="uppercase font-bold">
                            EST. DISPATCH: {stock.presaleDate}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}
